import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

import { FeaturedCategoryArticle } from 'src/components/featured-category-article/styles';
import {
  ProductToplist,
  ProductRow,
} from 'src/areas/expert/toplists/components/product-toplist/styles';

const HEADING_MARGIN = '45px';
export const GridWrapper = styled.div`
  display: grid;

  ${ProductToplist} {
    border: 1px solid ${props => props.theme.colors.base200};
    padding: ${layout.measurements.spacing075};
    margin: ${layout.measurements.spacing100} 0
      ${layout.measurements.spacing100} 0;
    border-radius: ${layout.measurements.spacing100};

    ${ProductRow} {
      grid-template-columns: ${55}px 1fr;
      column-gap: ${layout.measurements.spacing100};
    }

    ${media.largeUp`
      margin-top: ${HEADING_MARGIN};
        ${FeaturedCategoryArticle} {
          margin-right: ${layout.measurements.spacing150};
        }
    `}
  }
`;

export const GridArticleWrapper = styled(GridWrapper)`
  margin: 0 ${layout.measurements.spacing050};

  ${media.largeUp`
    grid-template-columns: 70% 1fr;
    align-items: start;
    ${FeaturedCategoryArticle} {
      margin-bottom: ${layout.measurements.spacing300};
    }
  `}
`;
